import { render, staticRenderFns } from "./IconTick.vue?vue&type=template&id=759d1641&scoped=true&"
import script from "./IconTick.vue?vue&type=script&lang=js&"
export * from "./IconTick.vue?vue&type=script&lang=js&"
import style0 from "./IconTick.vue?vue&type=style&index=0&id=759d1641&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759d1641",
  null
  
)

export default component.exports